import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";

import { appReducer } from "./reducers";

const rootReducer = combineReducers({
	app: appReducer,
});

const middleware = applyMiddleware(thunk);
const store = createStore(rootReducer, middleware);

export default store;
